import * as types from 'src/state/ducks/bakedBread/types';
import { Actions } from 'src/state/ducks/bakedBread/actions';
import { BakedBreadEntity, bakedBreadInitialEntity } from 'src/firebase/db/BakedBreads';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';
import { APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';

export interface State {
  isFetching: boolean;
  resource: BakedBreadEntity[];
  draft: BakedBreadEntity;
  validationErrors: ValidationResponse['errors'];
  apiError: APIFailedResponse['error'] | undefined;
  listType: 'list' | 'detail';
}

const initialState: State = {
  isFetching: false,
  resource: [],
  draft: bakedBreadInitialEntity,
  validationErrors: {},
  apiError: undefined,
  listType: 'detail',
};

const bakedBreadsReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case types.GET_BAKED_BREADS: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_GET_BAKED_BREADS: {
      return {
        ...state,
        isFetching: false,
        resource: action.payload.data,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_GET_BAKED_BREADS: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.GET_RESERVATION_BAKED_BREADS: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_GET_RESERVATION_BAKED_BREADS: {
      return {
        ...state,
        isFetching: false,
        resource: action.payload.data,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_GET_RESERVATION_BAKED_BREADS: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.GET_SHOP_BAKED_BREADS: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_GET_SHOP_BAKED_BREADS: {
      return {
        ...state,
        isFetching: false,
        resource: action.payload.data,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_GET_SHOP_BAKED_BREADS: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.SET_DRAFT: {
      return {
        ...state,
        draft: action.payload,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.SET_BAKED_BREADS_LIST_TYPE: {
      return {
        ...state,
        listType: action.payload,
      };
    }


    case types.CREATE_BAKED_BREAD: {
      return {
        ...state,
        isFetching: true,
        draft: action.payload,
      };
    }

    case types.SUCCESS_CREATE_BAKED_BREAD: {
      return {
        ...state,
        resource: [...state.resource, action.payload.data],
        draft: bakedBreadInitialEntity,
        isFetching: false,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_CREATE_BAKED_BREAD: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.UPDATE_BAKED_BREAD: {
      return {
        ...state,
        isFetching: true,
        draft: action.payload,
      };
    }

    case types.SUCCESS_UPDATE_BAKED_BREAD: {
      return {
        ...state,
        resource: [
          ...state.resource.filter((shop) => shop.id !== action.payload.data.id),
          action.payload.data,
        ],
        draft: bakedBreadInitialEntity,
        isFetching: false,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_UPDATE_BAKED_BREAD: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.UPDATE_BAKED_BREAD_ORDERS: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_UPDATE_BAKED_BREAD_ORDERS: {
      return {
        ...state,
        isFetching: false,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_UPDATE_BAKED_BREAD_ORDERS: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.INIT_BAKED_BREAD: {
      return initialState;
    }

    default:
      return state;
  }
};

export default bakedBreadsReducer;
